import LocationButton from "./location-button";

customElements.define("mx-location-button", LocationButton);
